module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "0",
      "margin-top": "0"
    }
  }, [_c('div', {
    ref: "espelhoDaProposta"
  }, [_c('v-layout', {
    staticStyle: {
      "position": "absolute",
      "z-index": "1",
      "left": "40px",
      "top": "40px"
    }
  }, [_c('v-btn', {
    staticClass: "btnGerarPDF",
    attrs: {
      "color": "primary",
      "onclick": "window.print()"
    }
  }, [_vm._v("Gerar PDF")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "align": "center",
      "margin": "0px 20px"
    }
  }, [_vm._v(_vm._s(_vm.relatorio.classificacoes[1].descricao) + " nº\n        " + _vm._s(this.relatorio.informacoes.idProjeto) + " - " + _vm._s(this.relatorio.informacoes.titulo))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Informações")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Título",
      "value": this.relatorio.informacoes.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Número",
      "value": this.relatorio.informacoes.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Situação",
      "value": this.relatorio.informacoes.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Tipo de público-alvo",
      "value": this.relatorio.informacoes.tipoPublico.descricao
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Público-alvo estimado",
      "value": this.relatorio.informacoes.publicoAlvo || ' '
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorio.classificacoes && (_vm.relatorio.classificacoes[1].id === 39729 || _vm.relatorio.classificacoes[1].id === 44194 || _vm.relatorio.classificacoes[1].id === 44195)) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Carga horária do curso",
      "value": this.relatorio.informacoes.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data de início",
      "value": _vm.relatorio.informacoes.dataInicio ? _vm.dates.format(_vm.relatorio.informacoes.dataInicio) || '-' : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data de conclusão",
      "value": _vm.relatorio.informacoes.dataConclusao ? _vm.dates.format(_vm.relatorio.informacoes.dataConclusao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Palavra-chave 1",
      "value": this.relatorio.informacoes.palavraChave01 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Palavra-chave 2",
      "value": this.relatorio.informacoes.palavraChave02 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Palavra-chave 3",
      "value": this.relatorio.informacoes.palavraChave03 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Palavra-chave 4",
      "value": this.relatorio.informacoes.palavraChave04 || ' '
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Resumo",
      "value": this.relatorio.informacoes.resumo || '-'
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Classificações")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers0,
      "items": _vm.relatorio.classificacoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.classificacoes.length) + " classificações\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Extensão")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Unidade",
      "value": _vm.relatorio.extensao.unidade ? _vm.relatorio.extensao.unidade.nome : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Órgão competente pela aprovação",
      "value": _vm.relatorio.extensao.orgaoCompetente ? _vm.relatorio.extensao.orgaoCompetente : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Coordenado por",
      "value": _vm.relatorio.extensao.coordenadoPor ? _vm.relatorio.extensao.coordenadoPor.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data da primeira apresentação",
      "value": _vm.relatorio.extensao.dtPrimeiraApresentacao ? _vm.dates.format(_vm.relatorio.extensao.dtPrimeiraApresentacao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data da última revisão",
      "value": _vm.relatorio.extensao.dtRevisao ? _vm.dates.format(_vm.relatorio.extensao.dtRevisao) || '-' : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data de aprovação pela Câmara de Extensão",
      "value": _vm.relatorio.extensao.dtAprovacao ? _vm.dates.format(_vm.relatorio.extensao.dtAprovacao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorio.informacoes.situacao.item === 17) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data de inabilitação pela Câmara de Extensão",
      "value": _vm.relatorio.extensao.dtInabilitacao ? _vm.dates.format(_vm.relatorio.extensao.dtInabilitacao) || '-' : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.discenteCoordenador) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Discente Coordenador",
      "value": _vm.relatorio.extensao.nomeDiscenteCoordenador || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Tipo de Evento",
      "value": _vm.relatorio.extensao.tipoEvento ? _vm.relatorio.extensao.tipoEvento.descricao : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.classificacoes[1].id === 39733) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "O programa é uma Empresa Júnior?",
      "value": _vm.relatorio.extensao.empresaJunior != null ? (_vm.relatorio.extensao.empresaJunior ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.classificacoes[1].id === 39733) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaEmpresaJunior",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n          Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores\n          deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.\n        ")]), _vm._v(" "), _c('br')], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Apresentação",
      "value": this.relatorio.extensao.apresentacao || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Justificativa / Mérito extensionista",
      "value": this.relatorio.extensao.justificativa || '-'
    }
  })], 1)], 1), _vm._v(" "), (this.relatorio.extensao.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Caracterização do público-alvo",
      "value": this.relatorio.extensao.caracterizacaoPublicoAlvo || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.relatorio.extensao.caracterizacaoPublicoAlvo && this.relatorio.informacoes.tipoPublico.item === 1) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Caracterização do público-alvo interno",
      "value": this.relatorio.extensao.publicoAlvoInterno || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.relatorio.extensao.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Caracterização do público-alvo externo",
      "value": this.relatorio.extensao.publicoAlvoExterno || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Objetivo geral",
      "value": this.relatorio.extensao.objetivosGerais || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px",
      "margin": "0px 30px"
    }
  }, [_vm._v("Objetivos específicos")]), _vm._v(" "), _vm._l((_vm.objetivosEspecificosTopicos), function(item, index) {
    return _c('p', {
      key: item.id,
      staticStyle: {
        "font-size": "16px",
        "margin": "0px 30px",
        "overflow-wrap": "break-word"
      },
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("\n          " + _vm._s(index + 1) + ". " + _vm._s(item.nome) + "\n          "), _c('br')])
  })], 2)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Metodologia",
      "align": "justify",
      "value": this.relatorio.extensao.metodologia || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorio.extensao.curso) ? _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Formas de avaliação dos cursistas",
      "value": this.relatorio.extensao.formaAvaliacao || '-'
    }
  }) : _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Forma de avaliação",
      "value": this.relatorio.extensao.formaAvaliacao || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Infraestrutura física",
      "value": this.relatorio.extensao.infraestruturaFisica || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Informações adicionais",
      "value": this.relatorio.extensao.informacoesAdicionais || '-'
    }
  })], 1)], 1), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px 30px"
    }
  }, [_vm._v("Tipo de Prestação de Serviço")]), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "items": _vm.listaTiposPrestacaoServico,
      "chips": "",
      "multiple": "",
      "readonly": ""
    },
    model: {
      value: (_vm.listaTiposPrestacaoServicoSelecionados),
      callback: function($$v) {
        _vm.listaTiposPrestacaoServicoSelecionados = $$v
      },
      expression: "listaTiposPrestacaoServicoSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Tipo de Prestação de Serviço",
      "value": '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia")]), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "value": "Espaços e Museus Culturais",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus Culturais")])]
      },
      proxy: true
    }], null, false, 1352582964),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "value": "Espaços e Museus de Ciência e Tecnologia",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus de Ciência e Tecnologia")])]
      },
      proxy: true
    }], null, false, 820644792),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "value": "Cines-clube",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Cines-clube")])]
      },
      proxy: true
    }], null, false, 2587689909),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "value": "Outros",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Serviço eventual")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de assessorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numAssessorias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numAssessorias", $$v)
      },
      expression: "this.relatorio.extensao.numAssessorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de consultorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numConsultorias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numConsultorias", $$v)
      },
      expression: "this.relatorio.extensao.numConsultorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de curadorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numCuradorias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numCuradorias", $$v)
      },
      expression: "this.relatorio.extensao.numCuradorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de outros",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numOutrosServicos),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numOutrosServicos", $$v)
      },
      expression: "this.relatorio.extensao.numOutrosServicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atividades de propriedade intelectual")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de depósito de patentes e modelos de utilidades",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numPatentesModelos),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numPatentesModelos", $$v)
      },
      expression: "this.relatorio.extensao.numPatentesModelos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de registro de marcas e softwares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numMarcasSoftwares),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numMarcasSoftwares", $$v)
      },
      expression: "this.relatorio.extensao.numMarcasSoftwares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de contratos de transferência de tecnologia",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numTransferenciaTecnologia),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numTransferenciaTecnologia", $$v)
      },
      expression: "this.relatorio.extensao.numTransferenciaTecnologia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de registros de direitos autorais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numDireitosAutorais),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numDireitosAutorais", $$v)
      },
      expression: "this.relatorio.extensao.numDireitosAutorais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Exames e laudos técnicos")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de laudos emitidos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numLaudosEmitidos),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numLaudosEmitidos", $$v)
      },
      expression: "this.relatorio.extensao.numLaudosEmitidos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento jurídico")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numAtendimentosJuridicos),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numAtendimentosJuridicos", $$v)
      },
      expression: "this.relatorio.extensao.numAtendimentosJuridicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde humana")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de consultas ambulatoriais (programadas)",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numConsultasAmbulatoriais),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numConsultasAmbulatoriais", $$v)
      },
      expression: "this.relatorio.extensao.numConsultasAmbulatoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de consultas de emergência e urgência",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numConsultasEmergencia),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numConsultasEmergencia", $$v)
      },
      expression: "this.relatorio.extensao.numConsultasEmergencia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de internações",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numInternacoes),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numInternacoes", $$v)
      },
      expression: "this.relatorio.extensao.numInternacoes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de cirurgias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numCirurgias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numCirurgias", $$v)
      },
      expression: "this.relatorio.extensao.numCirurgias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de exames laboratoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numExamesLaboratoriais),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numExamesLaboratoriais", $$v)
      },
      expression: "this.relatorio.extensao.numExamesLaboratoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de exames complementares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numExamesComplementares),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numExamesComplementares", $$v)
      },
      expression: "this.relatorio.extensao.numExamesComplementares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de outros atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numOutrosAtendimentosSH),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numOutrosAtendimentosSH", $$v)
      },
      expression: "this.relatorio.extensao.numOutrosAtendimentosSH"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde animal")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de atendimentos veterinários ambulatoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numAtendimentosVeterinarios),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numAtendimentosVeterinarios", $$v)
      },
      expression: "this.relatorio.extensao.numAtendimentosVeterinarios"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de internações veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numInternacoesVeterinarias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numInternacoesVeterinarias", $$v)
      },
      expression: "this.relatorio.extensao.numInternacoesVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de cirurgias veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numCirurgiasVeterinarias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numCirurgiasVeterinarias", $$v)
      },
      expression: "this.relatorio.extensao.numCirurgiasVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de exames laboratoriais e complementares em veterinária",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numExamesVeterinaria),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numExamesVeterinaria", $$v)
      },
      expression: "this.relatorio.extensao.numExamesVeterinaria"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico) ? _c('p', {
    staticStyle: {
      "margin": "2em"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Possui vínculo com ensino",
      "value": _vm.relatorio.extensao.vinculoEnsino != null ? (_vm.relatorio.extensao.vinculoEnsino ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Possui vínculo com pesquisa",
      "value": _vm.relatorio.extensao.vinculoPesquisa != null ? (_vm.relatorio.extensao.vinculoPesquisa ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Esta ação realiza divulgação científica",
      "value": _vm.relatorio.extensao.divulgacaoCientifica != null ? (_vm.relatorio.extensao.divulgacaoCientifica ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Envolve captação de recursos financeiros ou bens duráveis",
      "value": _vm.relatorio.extensao.captacaoRecursosBensDuraveis != null ? (_vm.relatorio.extensao.captacaoRecursosBensDuraveis ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 30px"
    }
  }, [_c('label', [_vm._v("Por meio de:")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosUfes),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosUfes", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosUfes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 3158995236),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosCapes),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosCapes", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosCapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosFest),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosFest", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 1739938252),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosCnpq),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosCnpq", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosCnpq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 4155422625),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosFapes),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosFapes", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosFapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosFucam),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosFucam", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosOutros", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosOutros"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Especifique:"
    },
    model: {
      value: (_vm.relatorio.extensao.especCaptacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "especCaptacaoRecursosOutros", $$v)
      },
      expression: "relatorio.extensao.especCaptacaoRecursosOutros"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação",
      "value": _vm.relatorio.extensao.liberacaoCargaHoraria != null ? (_vm.relatorio.extensao.liberacaoCargaHoraria ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorio.extensao.liberacaoCargaHoraria === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Carga horária aprovada",
      "value": this.relatorio.extensao.cargaHorariaCoordenadorAprovada || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.curso || _vm.relatorio.extensao.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Gratuito para o público",
      "value": _vm.relatorio.extensao.gratuito != null ? (_vm.relatorio.extensao.gratuito ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 30px"
    }
  }, [_c('label', [_vm._v("Os recursos financeiros obtidos serão administrados por:")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorio.extensao.gratuitoUfes),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "gratuitoUfes", $$v)
      },
      expression: "relatorio.extensao.gratuitoUfes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorio.extensao.gratuitoFest),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "gratuitoFest", $$v)
      },
      expression: "relatorio.extensao.gratuitoFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorio.extensao.gratuitoFucam),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "gratuitoFucam", $$v)
      },
      expression: "relatorio.extensao.gratuitoFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorio.extensao.gratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "gratuitoOutros", $$v)
      },
      expression: "relatorio.extensao.gratuitoOutros"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Especifique:"
    },
    model: {
      value: (_vm.relatorio.extensao.especGratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "especGratuitoOutros", $$v)
      },
      expression: "relatorio.extensao.especGratuitoOutros"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.curso) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Modalidade",
      "value": _vm.relatorio.extensao.modalidade != null ? (_vm.relatorio.extensao.modalidade == 'P' ? 'Presencial' : (_vm.relatorio.extensao.modalidade == 'S' ? 'Semipresencial' : 'EAD')) : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.curso) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Utiliza o AVA Extensão",
      "value": _vm.relatorio.extensao.utilizaAvaExtensao != null ? (_vm.relatorio.extensao.utilizaAvaExtensao ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.curso) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Outra plataforma AVA",
      "value": _vm.relatorio.extensao.plataforma || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Equipe")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers1,
      "items": _vm.relatorio.equipe,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui integrantes.'
    },
    scopedSlots: _vm._u([{
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor,
          props.item.funcao.item)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.equipe.length) + " integrantes\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Atividades")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers2,
      "items": _vm.relatorio.atividades,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui atividades.'
    },
    scopedSlots: _vm._u([{
      key: "item.nomeDescricao",
      fn: function(props) {
        return [(props.item.detalhamento !== null && props.item.detalhamento !== '') ? _c('div', [_vm._v("\n          " + _vm._s(props.item.descricao)), _c('br'), _c('br'), _vm._v(_vm._s(props.item.detalhamento))]) : _c('div', [_vm._v(_vm._s(props.item.descricao))])]
      }
    }, {
      key: "item.dtInicioPrevisto",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioPrevisto)))]
      }
    }, {
      key: "item.dtFimPrevisto",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimPrevisto)))]
      }
    }, {
      key: "item.dtInicioEfetivo",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioEfetivo)))]
      }
    }, {
      key: "item.dtFimEfetivo",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimEfetivo)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.atividades.length) + " atividades\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Vínculos")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers2b,
      "items": _vm.relatorio.vinculos,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui vínculos.'
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.vinculos.length) + " vínculos\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Parcerias")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers3,
      "items": _vm.relatorio.parcerias,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui parcerias.'
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de de " + _vm._s(_vm.relatorio.parcerias.length) + " parcerias\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Abrangência")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers4,
      "items": _vm.relatorio.abrangencia,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui localidades.'
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.abrangencia.length) + " localidades\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Arquivos")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers5,
      "items": _vm.relatorio.arquivos,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui arquivos.'
    },
    scopedSlots: _vm._u([{
      key: "item.dtInclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInclusao)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.arquivos.length) + " arquivos\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Contatos")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Site",
      "value": _vm.relatorio.contatos.site || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field-pre-format', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Mídias sociais",
      "value": _vm.relatorio.contatos.midiasSociais || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nome do contato",
      "value": _vm.relatorio.contatos.nomeContato || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "E-mail",
      "value": _vm.relatorio.contatos.email || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Telefone",
      "value": _vm.relatorio.contatos.telefone || '-'
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24eef6a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/consulta-projetos/relatorio.vue
// module id = 637
// module chunks = 0